module.exports = require("@swa-ui/core/src/FluidWidth/FluidWidth.module.scss");